import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))

export const RemindersRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--accounting--payment--reminders']}>
    <Route index element={<Index />} />
  </SubRouter>
))
